<h2 i18n>Agreement Form</h2>
<form (ngSubmit)="next()" (keydown.enter)="$event.preventDefault()">
    @if (error) {
    <div class="alert alert-danger" role="alert">
        {{error}}
    </div>
    }
    @switch (page)
    {
    @case (1) {
    <p i18n>
        Donate your contribution to our study here. This data donation portal is hosted by Utrecht University and the study, led by Professor Annette Markham. Before you donate your data, we want to make sure you’ve read the agreements and understand what is being asked of you, and that you understand how your data is being collected, managed, and used for research. Please review these two documents:
    </p>

        <ol>
            <li i18n><a href="assets/information-letter.pdf" target="_blank">General information sheet with details about researchers, purpose, ethics, and procedures</a></li>
            <li i18n><a href="assets/agreement-public-interest.pdf" target="_blank">Agreement to contribute your materials</a></li>
        </ol>

        <p i18n>For questions or concerns, please contact the primary researcher Annette Markham: <a href="mailto:a.n.markham@uu.nl">a.n.markham&#64;uu.nl</a>.</p>

        <p i18n>By ticking yes, you indicate your agreement to participate.</p>

        <ell-survey-question i18n-question question="Yes, I agree." type="checkbox" [(answer)]="answers['consentGiven']" name="consentGiven" />

        <p i18n class="mt-2">If you agree, portal access requires a code, which you will receive once you confirm via your email address. This email will not be kept after the data collection period and will not be shared, ever, with any third parties.</p>
    }
    }

    <input type="submit" class="btn btn-primary" value="Next" i18n-value />
</form>
